{
    "errors": {
        "required_field": "Este campo es obligatorio",
        "invalid_field": "Valor inválido",
        "invalid_email": "Correo electrónico inválido",
        "invalid_first_name":"Nombre inválido",
        "invalid_last_name":"Apellido inválido",
        "invalid_phone_number": "Número de teléfono inválido, inténtelo de nuevo",
        "server_error": "Algo salió mal. Inténtalo de nuevo más tarde.",
        "referral_used_error": "Lo sentimos, ya te has registrado con otro enlace de invitación.",
        "invalid_date_format": "Ingresa una fecha válida en el formato: MM-DD-YYYY",
        "invalid_date_format_YYYY": "Ingresa una fecha válida en el formato: YYYY-MM-DD",
        "existing_user_error": "Lo sentimos, ya te has registrado.",
        "pages": {
          "page_not_found": "Página no encontrada",
          "page_not_found_description": "¡Vaya! No encontramos la página que buscas.",
          "page_error": "Error de página",
          "page_error_description": "Uy, algo ha salido mal.",
          "suggested_pages": "Te sugerimos que eches un vistazo a una de estas páginas:"
        },
        "required_message": "{field} es obligatorio",
        "invalid_message": "Porfavor ingresa un {field} válido",
        "generic_error": "Ocurrió un error genérico."
      }
}